/**
 * Created by intellicar-sunny on 4/07/20.
 */
import React, {Component} from 'react';
import './AggregatedReport.css';
import DistanceReport from './DistanceReport';
import FuelReport from './FuelReport';
import {lightTheme, darkTheme} from '../../../../Layouts/config/mapConfig/mapStyleConfig'
import axios from 'axios';

class AggregatedReport extends Component{

    constructor(props){
        super(props);
        this.state={
            renderedLayout: 'distance',
            userGroups: []
        }
    }

    componentDidMount() {
        this.fetchUserGroups();
        document.getElementsByClassName("rwt-widget")[0].style.position="relative"

    }

    componentWillUnmount() {
        document.getElementsByClassName("rwt-widget")[0].style.position = "fixed";

    }

    

    fetchUserGroups(){
        let parentThis = this;
        const auth = window.getAuth();
        // console.log("auth data:",auth)
        let body = {
            "token" : auth.token
        }
        axios.post('https://apiplatform.intellicar.in/api/user/getmygroups', body)
            .then(function (response) {
                parentThis.setState({
                    userGroups: response.data.data,
                    selectedGroup: response.data.data[0].groupid
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    renderLayout() {
        if(this.state.renderedLayout === 'distance'){
            return(
                <DistanceReport selectedGroup={this.state.selectedGroup} />
            )
        }
        else if(this.state.renderedLayout === 'fuel'){
            return(
                <FuelReport />
            )
        }
    }

    renderGroupOptions() {
        return this.state.userGroups.map((group) => {
            // if((group.path.split("/")).length <= 6){ removed subgroup filter condition 
                return(
                    <option key={"group-"+group.groupid} value={group.groupid}>{group.name}</option>
                )
            // }
            
        })
    }

    render(){
        return(
            <div className="aggregatedReport">
                <div className="navigation">
                    <div className="groupSelectBox">
                        <select onChange={(e) => {this.setState({selectedGroup: e.target.value})}}>
                            {this.renderGroupOptions()}
                        </select>
                    </div>
                    <ul>
                        <li className={this.state.renderedLayout === 'distance' ? 'active' : ''} onClick={() => this.setState({renderedLayout:'distance'})} >Distance</li>
                        {/* <li className={this.state.renderedLayout === 'fuel' ? 'active' : ''} onClick={() => this.setState({renderedLayout:'fuel'})}>Fuel</li> */}
                    </ul>
                </div>

                {this.renderLayout()}

            </div>
        )
    }
}

export default AggregatedReport;